import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-3 row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt text-app-primary" }),
  /*#__PURE__*/_createTextVNode(" Home Health Episodes")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "col-12 mt-2" }
const _hoisted_4 = { class: "table table-responsive-md border mb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-table-header" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, "Episode"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, "Payer"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, "Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, "Reference ID Qualifier"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, "Reference ID")
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { class: "text-start" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_9 = {
  key: 1,
  class: "text-default"
}
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "text-default"
}
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "text-default"
}
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "text-default"
}
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text-default"
}
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "text-default"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.eligibility?.episode.success == 'Yes')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eligibility.episode.episodes, (episode) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_6, [
                    (episode.period_date_range)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(episode.period_date_range.split("-")[0])), 1 /* TEXT */),
                          _hoisted_8,
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(episode.period_date_range.split("-")[1])), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("i", _hoisted_9, "Not Available"))
                  ]),
                  _createElementVNode("td", _hoisted_10, [
                    (episode.payer)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(episode.payer), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("i", _hoisted_12, "Not Available"))
                  ]),
                  _createElementVNode("td", _hoisted_13, [
                    (episode.name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(episode.name), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("i", _hoisted_15, "Not Available"))
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    (episode.date)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.formatDate(episode.date)), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("i", _hoisted_18, "Not Available"))
                  ]),
                  _createElementVNode("td", _hoisted_19, [
                    (episode.reference_id_qualifier)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(episode.reference_id_qualifier), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("i", _hoisted_21, "Not Available"))
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    (episode.reference_id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(episode.reference_id), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("i", _hoisted_24, "Not Available"))
                  ])
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}